// removed by extract-text-webpack-plugin
module.exports = {"HousingMenuTitle":"Housing__HousingMenuTitle___2fN3B","HousingMenuItem":"Housing__HousingMenuItem___3BB66","RadioIcon":"Housing__RadioIcon___3tRu_","Active":"Housing__Active___hTr3T","Status":"Housing__Status___3n18Z","Finished":"Housing__Finished___2lD2z","InProcess":"Housing__InProcess___1xBP7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Building/Chess/Filters/Housing/Housing.scss
// module id = 1334
// module chunks = 0